import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 mt-auto">
      <div className="container mx-auto px-4 text-center">
        <p className="text-xs text-gray-500">
          평가몬은 서버에 개인정보를 저장하지 않습니다. 안심하세요. 그저 행복한 한기말을 맞이하세요. _ 전주사는 도요새로부터
        </p>
      </div>
    </footer>
  );
};

export default Footer;

